import type { Translation } from "./uz";

// Russian placeholders. RU strings run ~20-30% longer than UZ — leave room in layouts.
// TODO(i18n): proper RU copy pass. For now mirror the UZ keys so the app stays bilingual-ready.
export const ru: Translation = {
  app: {
    name: "Nasiyah",
    support: "SUPPORT",
    loading: "Загрузка…",
  },
  nav: {
    sectionMain: "ГЛАВНОЕ",
    sectionClients: "РАБОТА С КЛИЕНТАМИ",
    sectionTools: "ИНСТРУМЕНТЫ",
    sectionSystem: "СИСТЕМА",
    overview: "Обзор",
    metrics: "Метрики",
    renewals: "Клиенты",
    customers: "Пользователи",
    import: "Импорт",
    notifications: "Уведомления",
    catalogue: "Каталог",
    settings: "Настройки",
    logout: "Выйти",
    // One-line explanation under each sidebar entry (0153).
    hint: {
      overview: "Состояние системы сегодня",
      metrics: "Рост, выручка, активность",
      renewals: "Премиум-мерчанты и сроки",
      customers: "Все зарегистрированные",
      import: "Клиенты и договоры мерчанта",
      catalogue: "Марки авто и техники",
      notifications: "Отправка push-сообщений",
      settings: "Цены и контакты",
    },
  },
  topbar: {
    searchPlaceholder: "Поиск…",
    menu: "Меню",
    openMenu: "Открыть меню",
    closeMenu: "Закрыть меню",
    alerts: "Оповещения",
  },
  table: {
    sortBy: "Сортировать",
    sortDefault: "По умолчанию",
    sortAsc: "По возрастанию",
    sortDesc: "По убыванию",
  },
  placeholder: {
    soon: "Этот раздел пока не готов.",
  },
  auth: {
    title: "Панель поддержки",
    subtitle: "Войдите под учётной записью оператора",
    phoneLabel: "Номер телефона",
    phonePlaceholder: "+998 90 123 45 67",
    sendCode: "Отправить код",
    codeLabel: "Код подтверждения",
    codeHint: "Введите 4-значный код из SMS",
    enter: "Войти",
    back: "Назад",
    resend: "Отправить код повторно",
    sending: "Отправка…",
    verifying: "Проверка…",
    noPermission: "У вас нет прав поддержки.",
    genericError: "Произошла ошибка. Попробуйте снова.",
    invalidPhone: "Введите номер телефона полностью.",
    invalidCode: "Введите код полностью.",
    wrongCode: "Неверный или просроченный код.",
  },
  customers: {
    title: "Пользователи",
    searchPlaceholder: "Поиск по имени, телефону или ID",
    statusAll: "Все статусы",
    count: "{{count}} пользователей",
    export: "Экспорт",
    import: "Импорт",
    colCustomer: "Пользователь",
    colPhone: "Телефон",
    colContracts: "Догов.",
    colStatus: "Статус",
    colActivity: "Активность",
    sortContracts: "Количество договоров",
    cardContracts: "Договоров: {{count}}",
    premiumBadge: "Премиум",
    edit: "Изменить",
    empty: "Пользователи не найдены",
    emptyHint: "Измените поиск или фильтры.",
    clearFilters: "Сбросить фильтры",
    loadError: "Не удалось загрузить данные.",
    rangeShown: "{{from}}–{{to}} из {{total}}",
    ago: "{{value}} назад",
    never: "Никогда",
    searchLabel: "Поиск пользователей",
    openCustomer: "{{name}} — открыть карточку",
    prevPage: "Предыдущая",
    nextPage: "Следующая",
    pageLabel: "Страница {{page}}",
    pagination: "Постраничная навигация",
  },
  status: {
    active: "Активный",
    inactive: "Неактивный",
    new: "Новый",
  },
  drawer: {
    // ── Detail tabs (0068) ──
    tabIdentity: "Данные",
    tabAccount: "Счёт",
    tabTimeline: "История",
    unsavedBadge: "Несохранённые изменения",
    registeredOn: "зарегистрирован {{date}}",
    verifyBanner:
      "Данные клиента требуют проверки — идентификация неполная.",
    sectionPersonal: "Личные данные",
    sectionDocument: "Документ",
    sectionAddress: "Адрес",
    sectionAccount: "Счёт",
    firstName: "Имя",
    lastName: "Фамилия",
    phone: "Номер телефона",
    birthDate: "Дата рождения",
    passport: "Серия паспорта",
    pin: "ПИНФЛ / ЖШШИР",
    address: "Адрес",
    status: "Статус",
    balance: "Баланс",
    premium: "Премиум",
    freeTier: "Бесплатный тариф",
    premiumUntil: "до {{date}}",
    premiumFree: "бесплатно",
    premiumPaid: "платно",
    premiumRepeatable: "повторяемый",
    freeRemaining: "осталось бесплатных: {{count}}",
    developerBadge: "Developer",
    cancel: "Отмена",
    save: "Сохранить",
    saving: "Сохранение…",
    loadError: "Не удалось загрузить данные клиента.",
    saved: "Данные клиента сохранены",
    conflict: "Этот телефон или документ уже используется.",
    saveError: "Ошибка сохранения. Попробуйте снова.",
    // ── Locked view / edit mode (0153) ──
    edit: "Редактировать",
    lockedHint: "Режим просмотра. Паспорт и ПИНФЛ скрыты.",
    editingHint: "Режим редактирования — сохраните или отмените изменения.",
    changedCount: "Изменено полей: {{count}}",
    // ── Sensitive operations (0063.04) ──
    opsSection: "Операции",
    developerMode: "Режим разработчика",
    makeDeveloper: "Включить режим разработчика",
    removeDeveloper: "Выключить режим разработчика",
    developerWarning:
      "При включении код подтверждения входа (OTP) для этого пользователя станет фиксированным — 7777 (бэкдор). Используйте только при необходимости.",
    addFunds: "Пополнить",
    withdrawFunds: "Списать",
    amount: "Сумма",
    reason: "Причина",
    reasonPlaceholder: "необязательно",
    balanceConfirmCredit: "Пополнить баланс на {{amount}} сум?",
    balanceConfirmDebit: "Списать с баланса {{amount}} сум?",
    convertPremium: "Перевести на Премиум",
    premiumPaidOption: "Платно (списать с баланса)",
    premiumFreeOption: "Бесплатно (осталось: {{count}})",
    premiumConfirmPaid: "Перевести клиента на Премиум с оплатой с баланса?",
    premiumConfirmFree: "Перевести клиента на бесплатный Премиум?",
    confirm: "Подтвердить",
    processing: "Выполняется…",
    opSuccess: "Операция выполнена",
    balanceLow: "Недостаточно средств.",
    alreadyPremium: "Этот клиент уже премиум.",
    noFreeLeft: "Бесплатные премиумы закончились.",
    opError: "Не удалось выполнить операцию. Попробуйте снова.",
    // ── Unsaved-changes guard (0067.02) ──
    unsavedTitle: "Есть несохранённые изменения",
    unsavedDiscard: "Отменить",
    unsavedKeep: "Продолжить редактирование",
  },
  timeline: {
    sectionHistory: "История клиента",
    sectionSupportActions: "Действия поддержки",
    empty: "Пока нет записей",
    registered: "Зарегистрирован",
    statusChange: "Статус изменён",
    developerOn: "Режим разработчика включён",
    developerOff: "Режим разработчика выключен",
    balanceCredit: "Баланс пополнен",
    balanceDebit: "С баланса списано",
    premiumGranted: "Премиум выдан",
    identityCorrected: "Данные исправлены",
    by: "оператор: {{name}}",
    reason: "Причина: {{reason}}",
  },
  // ── Customer's own app activity (0153) ──
  activity: {
    title: "Активность в приложении",
    period: {
      last5: "Последние 5",
      "7d": "7 дней",
      all: "Всё",
    },
    total: "Всего: {{count}}",
    today: "Сегодня",
    yesterday: "Вчера",
    loadMore: "Загрузить ещё",
    empty: "Нет активности",
    emptyHint: {
      last5: "Пользователь ещё ничего не делал в приложении.",
      "7d": "За последние 7 дней действий в приложении не было.",
      all: "Пользователь ещё ничего не делал в приложении.",
    },
    loadError: "Не удалось загрузить активность.",
    retry: "Повторить",
    app: {
      merchant: "Мерчант",
      client: "Клиент",
    },
    actions: {
      user: {
        login: "Вошёл в приложение",
        register: "Зарегистрировался",
        client_add: "Добавил клиента",
        client_remove: "Удалил клиента",
        profile_update: "Изменил профиль",
        delete: "Удалил аккаунт",
      },
      loan: {
        create: "Создал договор",
        verify: "Отправил договор клиенту",
        activate: "Принял договор",
        reject: "Отклонил договор",
        pause: "Изменил статус договора",
        cancel: "Отменил договор",
        finish: "Договор завершён",
        delete: "Удалил договор",
      },
      payment: {
        create: "Отправил платёж",
        part_create: "Отправил частичный платёж",
        several_create: "Оплатил несколько месяцев",
        custom_create: "Платёж на произвольную сумму",
        approve: "Подтвердил платёж",
        reject: "Отклонил платёж",
        delay: "Отсрочил платёж",
        complete: "Платёж завершён",
        mark_paid: "Отметил как оплаченный",
      },
      premium: {
        activate: "Активировал премиум",
        renew: "Продлил премиум",
        deactivate: "Премиум закончился",
        free_use: "Использовал бесплатный премиум",
      },
      debt: {
        create: "Записал долг",
        update: "Изменил долг",
        delete: "Удалил долг",
        settle: "Рассчитался по долгу",
        cash_update: "Обновил кассу",
      },
    },
    categories: {
      payment: "Платёж",
      loan: "Договор",
      user: "Профиль",
      auth: "Вход",
      premium: "Премиум",
      debt: "Долг",
    },
    paymentType: {
      FULL: "Полное закрытие",
      MONTHLY_FULL: "Ежемесячный платёж",
      MONTHLY_PART: "Часть ежемесячного",
      CLOSE_PART: "Частичное закрытие",
      DELAYED: "Просроченный",
      IN_ADVANCE: "Досрочно",
    },
    loanStatus: {
      active: "Активный",
      paused: "Приостановлен",
      pending: "Ожидает",
      draft: "Черновик",
      finished: "Завершён",
      cancelled: "Отменён",
      rejected: "Отклонён",
    },
    agreement: "Договор #{{id}}",
    payment: "Платёж #{{id}}",
    debt: "Долг #{{id}}",
    client: "Клиент {{code}}",
    amount: "Сумма: {{amount}}",
    cash: "Касса: {{amount}}",
    months: "Месяцев: {{count}}",
    newStatus: "Новый статус: {{status}}",
    nextMonth: "на следующий месяц",
    autoApproved: "автоподтверждён",
    reason: "Причина: «{{reason}}»",
  },
  settings: {
    loadError: "Не удалось загрузить настройки.",
    saved: "Настройка сохранена",
    saving: "Сохранение…",
    save: "Сохранить",
    unsaved: "Несохранённые изменения",
    revert: "Отменить",
    premiumTitle: "Цена Премиума",
    premiumHint: "Сумма, списываемая с баланса при покупке клиентом подписки Премиум.",
    currencySuffix: "сум",
    priceInvalid: "Цена должна быть не меньше 0.",
    supportTitle: "Ссылка поддержки",
    supportHint: "Ссылка на Telegram, которую клиенты открывают из раздела «Помощь» в приложении.",
    testLink: "Открыть и проверить ссылку",
    linkInvalid: "Введите корректную ссылку (должна начинаться с https://).",
    phoneTitle: "Телефон поддержки",
    phoneHint: "Номер телефона, который клиенты видят на лендинге и могут набрать.",
    phoneInvalid: "Введите полный номер телефона в международном формате.",
    freeTierTitle: "Срок бесплатного тарифа",
    freeTierHint:
      "Сколько месяцев действует бесплатный Премиум при выдаче оператором. Изменение влияет только на новые выдачи — действующие подписки не меняются.",
    monthsSuffix: "мес.",
    monthsInvalid: "Срок должен быть не менее 1 месяца.",
    saveError: "Ошибка сохранения. Попробуйте снова.",
  },
  import: {
    back: "Назад",
    steps: {
      ariaLabel: "Этапы импорта",
      merchant: "Мерчант",
      mode: "Способ",
      data: "Данные",
      result: "Результат",
    },
    dropzone: {
      label: "Выберите файл или перетащите сюда",
      hint: "Принимаются только файлы .xlsx и .xls",
      invalidType: "Загрузите файл только .xlsx или .xls",
      clear: "Удалить файл",
    },
    merchantStep: {
      title: "Выберите мерчанта",
      subtitle: "Выберите мерчанта, для которого выполняется импорт.",
      searchPlaceholder: "Поиск по имени или телефону",
      clientCount: "{{count}} клиентов",
      count: "{{count}} мерчантов",
      empty: "Мерчанты не найдены",
    },
    modeStep: {
      title: "Выберите способ импорта",
      // Section headings for the two semantic groups
      sectionCustomers: "Клиенты",
      sectionAgreements: "Договоры",
      fileMode: "Импорт из файла",
      fileModeHint: "Массовый импорт через файл .xlsx",
      manualMode: "Добавить вручную",
      manualModeHint: "Добавить одного клиента вручную",
      agreementMode: "Импорт договоров",
      agreementModeHint: "Импорт договоров через файл .xlsx",
      // New card: add a single agreement manually via side drawer (0119)
      agreementManualMode: "Добавить договор",
      agreementManualModeHint: "Добавить один договор вручную",
    },
    fileStep: {
      title: "Импорт из файла",
      downloadTemplate: "Скачать шаблон",
      dropzone: "Выберите файл или перетащите сюда",
      dropzoneHint: "Принимаются только файлы .xlsx и .xls",
      readyCount: "Готово",
      existsCount: "Существует",
      errorCount: "Ошибки",
      colRow: "#",
      colName: "Имя Фамилия",
      colPhone: "Телефон",
      colStatus: "Статус",
      colNote: "Примечание",
      statusReady: "Готово",
      statusExists: "Существует",
      statusError: "Ошибка",
      existsHint: "Этот {{field}} уже принадлежит {{name}}",
      fieldPhone: "телефон",
      fieldPin: "ПИНФЛ",
      commitBtn: "Импортировать ({{count}} готово)",
      resultTitle: "Импорт завершён",
      imported: "Импортировано",
      skipped: "Пропущено",
      errors: "Ошибки",
      newImport: "Новый импорт",
      viewCustomers: "Список клиентов",
      noReady: "Нет готовых строк — ничего не будет импортировано. Проверьте файл.",
      onlyErrors: "Только ошибки ({{count}})",
      importedToast: "{{count}} клиентов успешно импортировано",
    },
    manualStep: {
      title: "Добавить вручную",
      first_name: "Имя",
      first_namePlaceholder: "Например: Сардор",
      last_name: "Фамилия",
      last_namePlaceholder: "Например: Холматов",
      phone_number: "Номер телефона",
      phone_numberPlaceholder: "+998901234567",
      pin: "ПИНФЛ / ЖШШИР",
      pinPlaceholder: "14-значный ПИНФЛ",
      passport_number: "Серия паспорта",
      passport_numberPlaceholder: "AA1234567",
      birth_date: "Дата рождения",
      birth_datePlaceholder: "",
      address: "Адрес",
      addressPlaceholder: "Ташкент, Чиланзар, дом 12",
      submitBtn: "Добавить",
      successToast: "{{name}} успешно добавлен",
      sessionCount: "В этой сессии добавлено клиентов: {{count}}",
      validation: {
        required: "Заполните это поле",
        phone: "Введите корректный номер телефона",
        pin: "ПИНФЛ должен состоять из 14 цифр",
      },
    },
    errors: {
      phone_exists: "Этот номер телефона уже зарегистрирован.",
      pin_exists: "Этот ПИНФЛ уже зарегистрирован.",
      passport_exists: "Эта серия паспорта уже зарегистрирована.",
      invalid_phone: "Неверный формат номера телефона.",
      invalid_pin: "Неверный формат ПИНФЛ.",
      generic: "Произошла ошибка. Попробуйте снова.",
    },
    agreements: {
      title: "Импорт договоров",
      downloadTemplate: "Скачать шаблон",
      dropzone: "Выберите файл или перетащите сюда",
      dropzoneHint: "Принимаются только файлы .xlsx и .xls",
      readyCount: "Готово",
      existsCount: "Существует",
      errorCount: "Ошибки",
      colRow: "#",
      colClient: "Клиент",
      colIdentifier: "Идентификатор",
      colType: "Тип",
      colName: "Товар/Модель",
      colCost: "Себестоимость",
      colSellingPrice: "Цена",
      colDownPayment: "Первонач. взнос",
      colMonthlyPayment: "Ежемес. платёж",
      colPaymentCount: "Кол-во платежей",
      colStartDate: "Дата начала",
      colPaymentDay: "День платежа",
      colPaidAmount: "Оплачено",
      colNote: "Примечание",
      colReminder: "Напомнить (дни)",
      colMessage: "Статус-комментарий",
      statusReady: "Готово",
      statusExists: "Существует",
      statusError: "Ошибка",
      existsHint: "Договор уже существует: {{code}}",
      missingFields: "Не заполнено: {{fields}}",
      // Pre-commit detail drawer trigger (last preview column) + its button tooltip.
      detailCol: "Детали",
      detailBtnTitle: "Открыть детали / заполнить",
      editHint: "Ячейки можно редактировать прямо здесь",
      revalidating: "Проверяется…",
      commitBtn: "Импортировать ({{count}} готово)",
      resultTitle: "Импорт завершён",
      imported: "Импортировано",
      skipped: "Пропущено",
      errors: "Ошибки",
      newImport: "Новый импорт",
      importedToast: "{{count}} договоров успешно импортировано",
      loanType: {
        car: "Авто",
        building: "Строительство",
        technology: "Техника",
        loan: "Кредит",
        other: "Другое",
        service: "Услуга",
      },
      // Pre-commit detail drawer (0085) — context panel with read-only + edit sections.
      detail: {
        contextTitle: "Данные договора",
        editTitle: "Редактирование",
      },
      // Edit drawer — opened from the import-result list for each created agreement.
      edit: {
        drawerTitle: "Редактировать детали договора",
        editBtn: "Изменить",
        missingHint: "{{count}} полей не заполнено",
        saveBtn: "Сохранить",
        cancelBtn: "Отмена",
        savedToast: "Детали сохранены",
        loadError: "Не удалось загрузить данные.",
        saveError: "Ошибка сохранения. Попробуйте снова.",
        // Locked money/schedule section shown for context (read-only).
        sectionLocked: "Финансовые данные (только для просмотра)",
        lockedSellingPrice: "Стоимость",
        lockedDownPayment: "Первоначальный взнос",
        lockedMonthlyPayment: "Ежемесячный платёж",
        lockedPaymentCount: "Количество платежей",
        // Catalogue dropdown labels for model field (car / technology).
        model: "Модель",
        modelSearch: "Поиск...",
        modelPlaceholder: "Выберите модель",
        colorPlaceholder: "Выберите цвет",
        // Per-field labels for additional_data keys (rendered dynamically from editable_fields).
        fields: {
          number: "Гос. номер",
          vin: "VIN-номер",
          engine_number: "Номер двигателя",
          color: "Цвет",
          production_date: "Год выпуска",
          mileage: "Пробег (км)",
          serial_number: "Серийный номер",
          comment: "Комментарий",
        },
      },
      // Pre-commit detail drawer (0085) — opened from a ready preview row's info button. Reuses
      // edit.fields.* labels and edit.saveBtn/cancelBtn; only the wrapper texts are new.
      previewDetail: {
        drawerTitle: "Детали договора",
        subtitle: "Вы можете заполнить пустые поля до импорта",
        noFields: "Для этого типа нет дополнительных полей",
      },
      // Payment-progress block (Feature A) shown at the top of the edit drawer.
      progress: {
        title: "График платежей",
        started: "Начало",
        current: "Текущий платёж",
        currentDone: "Завершён",
        paid: "Оплачено",
        left: "Осталось платежей",
        finish: "Дата окончания",
        remaining: "Остаток долга",
        legendDone: "Оплаченный месяц",
        legendPartial: "Частично (пропорц.)",
        legendUnpaid: "Не оплачено",
      },
      // Model-match badge labels shown in the agreement preview table.
      match: {
        legendTitle: "Соответствие модели:",
        matched: "найдено в каталоге",
        suggested: "предложение",
        unmatched: "нет в каталоге",
        didYouMean: "Вы имели в виду: {{suggestion}}?",
      },
      // Inline catalogue-add modal (Feature C) — add a brand/model to the global catalogue.
      catalogue: {
        addToCatalogue: "Добавить в каталог",
        modalTitle: "Добавить товар в каталог",
        selectBrand: "Выберите марку",
        newBrand: "Новая марка",
        selectModel: "Выберите модель",
        newModel: "Новая модель",
        add: "Добавить",
        confirm: "Подтвердить",
        cancel: "Отмена",
        brandAdded: "Марка добавлена",
        modelAdded: "Модель добавлена",
      },
    },
    // ── Single-agreement manual add drawer (0119) ──────────────────────────
    agreementAdd: {
      drawerTitle: "Добавить договор",
      customerSection: "Клиент",
      agreementSection: "Договор",
      customer: {
        existing: "Существующий клиент",
        new: "Новый клиент",
        selectPlaceholder: "Выберите клиента",
        searchPlaceholder: "Поиск по имени или телефону",
        searchHint: "Введите для поиска",
        empty: "Клиент не найден",
        change: "Изменить",
      },
      fields: {
        type: "Тип",
        name: "Название товара",
        namePlaceholder: "Например: Холодильник",
        model: "Модель",
        modelPlaceholder: "Выберите модель",
        modelSearch: "Поиск...",
        color: "Цвет",
        colorPlaceholder: "Выберите цвет",
        cost_price: "Себестоимость",
        selling_price: "Цена",
        down_payment: "Первоначальный взнос",
        monthly_payment: "Ежемесячный платёж",
        payment_count: "Кол-во платежей",
        paid_amount: "Оплачено",
        payment_day: "День платежа",
        first_payment_date: "Дата первого платежа",
        notification_before: "За сколько дней напомнить",
        note: "Примечание",
        monthlyAvgHint: "Средний платёж: {{amount}}",
        cost_pricePlaceholder: "Например: 800",
        selling_pricePlaceholder: "Например: 1 000",
        down_paymentPlaceholder: "Например: 200",
        monthly_paymentPlaceholder: "Например: 100",
        payment_countPlaceholder: "Например: 12",
        paid_amountPlaceholder: "Например: 100",
        payment_dayPlaceholder: "Например: 15",
        first_payment_datePlaceholder: "Выберите дату",
        notification_beforePlaceholder: "Например: 3",
        notePlaceholder: "Дополнительное примечание (необязательно)",
      },
      // "To'langan" input mode toggle (0123): money sum vs. number of monthly instalments paid.
      paidMode: {
        amount: "Сумма",
        count: "Кол-во платежей",
        countPlaceholder: "Например: 3",
        moneyHint: "= {{amount}} сум",
        needMonthly: "Сначала укажите ежемесячный платёж",
      },
      validation: {
        required: "Заполните это поле",
        customerRequired: "Выберите клиента или введите данные нового клиента",
      },
      submitBtn: "Сохранить",
      reviewBtn: "Просмотреть",
      cancelBtn: "Отмена",
      successToast: "Договор добавлен: {{code}}",
      sessionCount: "В этой сессии добавлено договоров: {{count}}",
      // Contract preview ("dogovor") shown before saving — mirrors the merchant app's preview screen.
      preview: {
        title: "Договор",
        subtitle: "Проверьте перед подтверждением",
        clientSection: "Клиент",
        agreementSection: "Договор",
        financialSection: "Финансы",
        scheduleSection: "График платежей",
        notificationSection: "Напоминание",
        clientName: "Ф.И.О.",
        clientPhone: "Телефон",
        clientPassport: "Паспорт",
        clientPin: "ПИНФЛ",
        confirmBtn: "Подтвердить",
        editBtn: "Редактировать",
        downloadBtn: "Скачать",
        pdfError: "PDF недоступен — данные показаны ниже",
      },
    },
    // ── Searchable colour picker (0120) ────────────────────────────────────
    colorSelect: {
      search: "Поиск цвета...",
    },
    // ── Import history panel (0116.04) ──────────────────────────────────────
    importHistory: {
      title: "Последние импорты",
      colDate: "Дата",
      colActor: "Оператор",
      colMerchant: "Мерчант",
      colFilename: "Файл",
      colImported: "Импортировано",
      colSkipped: "Пропущено",
      colErrors: "Ошибки",
      colTotal: "Всего",
      empty: "Импортов ещё не было",
      loading: "Загрузка…",
      noFile: "—",
      expand: "Показать договоры",
      collapse: "Свернуть",
      noDetail: "Для этой записи нет деталей",
    },
  },
  notifications: {
    composeTitle: "Новое уведомление",
    // Recipients
    recipientsLabel: "Получатели",
    recipientAll: "Все клиенты",
    recipientSegment: "Сегмент",
    recipientSingle: "Один клиент",
    // Segment filters (status × premium — mirrors backend UserStatus)
    segStatus: "Статус",
    segStatusAll: "Все клиенты",
    segStatusActive: "Активные клиенты",
    segStatusInactive: "Неактивные клиенты",
    segStatusNew: "Новые клиенты",
    segPremium: "Только Premium",
    // Single recipient (merchant picker — GET /support/merchants/?search=)
    singleSelect: "Выберите мерчанта",
    singlePlaceholder: "Поиск по имени или телефону…",
    merchantPickHint: "Введите имя или номер, чтобы выбрать одного.",
    merchantNotFound: "Мерчант не найден.",
    merchantChange: "Изменить",
    merchantClients: "{{n}} клиентов",
    // Channel
    channelLabel: "Канал",
    channelPush: "Push",
    channelSms: "SMS",
    channelBoth: "Оба",
    channelBothTable: "Push + SMS",
    // Content language (task 0081 — оба языка UZ + RU обязательны для отправки)
    contentLang: "Язык",
    langUz: "Узбекский",
    langRu: "Русский",
    fillBothLangs: "Заполните оба языка (UZ и RU) для отправки.",
    // Title + body
    title: "Заголовок",
    titleHint: "— в приложении показывается жирным",
    titlePlaceholder: "Напоминание о платеже",
    bodyLabel: "Текст",
    bodyPlaceholder: "Сообщение, которое получат клиенты",
    bodyHelp: "Пишите в форме Siz/Вы",
    // Personalization chip — inserts the {name} token at the cursor; backend swaps it per recipient.
    insertNameChip: "Добавить имя",
    insertNameHint: "При отправке заменяется именем каждого клиента.",
    // Send time
    sendTimeLabel: "Время отправки",
    sendNow: "Отправить сейчас",
    sendNowHint: "Сразу после подтверждения",
    sendSchedule: "Запланировать",
    sendScheduleHint: "Укажите дату и время",
    scheduleAtLabel: "Дата и время отправки",
    scheduleFutureError: "Время должно быть в будущем.",
    // Footer
    saveDraft: "Сохранить черновик",
    draftSaved: "Черновик сохранён",
    send: "Отправить",
    sending: "Отправка…",
    // Preview
    previewLabel: "Предпросмотр",
    previewNow: "Сейчас",
    previewTitlePlaceholder: "Заголовок",
    previewBodyPlaceholder: "Текст уведомления",
    // Stats
    statsUnit: "получатель",
    statsRealNote: "Количество получателей определяется после отправки.",
    reachPush:
      "Через push дойдёт до ~{{reach}} устройств. Клиентам с отключённым push не отправляется.",
    reachSms: "Через SMS будет отправлено на {{total}} номеров.",
    reachBoth: "Через Push + SMS получат {{total}} клиентов.",
    // Confirm
    confirmTitle: "Отправить уведомление?",
    confirmBody:
      "Это уведомление получат {{n}} клиентов. Действие необратимо.",
    confirmBodyNoCount:
      "Это уведомление будет отправлено выбранным получателям. Действие необратимо.",
    confirmYes: "Да, отправить",
    cancel: "Отмена",
    sent: "Уведомление отправлено",
    // History table
    historyTitle: "Отправленные уведомления",
    colTitle: "Заголовок",
    colRecipients: "Получатели",
    colChannel: "Канал",
    colDelivered: "Доставлено",
    colDate: "Дата",
    colStatus: "Статус",
    statusSent: "Отправлено",
    statusScheduled: "Запланировано",
    statusDraft: "Черновик",
    statusCancelled: "Отменено",
    // Cancel a still-pending scheduled broadcast
    cancelScheduled: "Отменить",
    cancelling: "Отмена…",
    cancelled: "Запланированное уведомление отменено",
    empty: "Уведомления ещё не отправлялись",
    emptyHint: "Отправленные уведомления появятся здесь.",
    loadError: "Не удалось загрузить уведомления.",
    // Inline errors
    contentRequired: "Заполните заголовок и текст для обоих языков.",
    forbidden: "У вас нет прав на отправку уведомлений.",
    sendError: "Ошибка отправки. Попробуйте снова.",
    // Guided steps
    stepMessage: "Текст уведомления",
    // Per-language helpers (tab + smart help)
    copyToRu: "Скопировать на русский",
    copyToUz: "Скопировать на узбекский",
    copied: "Текст скопирован на другой язык",
    incompleteWarnUz: "Текст на узбекском ещё не заполнен",
    incompleteWarnRu: "Текст на русском ещё не заполнен",
    // Readiness checklist
    readyTitle: "Готово к отправке?",
    readyRecipient: "Получатель выбран",
    readyUz: "Текст на узбекском заполнен",
    readyRu: "Текст на русском заполнен",
    readyTiming: "Время отправки указано",
  },
  time: {
    minutes: "{{count}} минут",
    hours: "{{count}} часов",
    days: "{{count}} дней",
    justNow: "только что",
  },
  catalogue: {
    title: "Каталог",
    searchPlaceholder: "Поиск по марке",
    car: "Авто",
    technology: "Техника",
    addBrand: "Добавить марку",
    addModel: "Добавить модель",
    brandNameLabel: "Введите название марки",
    modelNameLabel: "Введите название модели",
    colBrand: "Марка",
    colModel: "Модель",
    colModels: "Модели",
    edit: "Изменить",
    delete: "Удалить",
    rename: "Переименовать",
    save: "Сохранить",
    cancel: "Отмена",
    confirm: "Подтвердить",
    add: "Добавить",
    deleteBrandTitle: "Удалить марку",
    deleteBrandHint: "Эта марка и {{count}} связанных моделей будут скрыты из каталога. Существующие договоры сохранят своё название; при желании можно вернуть позже.",
    deleteModelTitle: "Удалить модель",
    deleteModelHint: "Эта модель будет скрыта из каталога. Существующие договоры сохранят своё название; при желании можно вернуть позже.",
    empty: "Марок пока нет",
    emptyHint: "Добавьте первую марку ниже.",
    noResults: "По запросу марки не найдены",
    loadError: "Не удалось загрузить данные.",
    saved: "Сохранено",
    deleted: "Удалено",
    error: "Произошла ошибка. Попробуйте снова.",
    brandsCount: "{{count}} марок",
    modelsCount: "{{count}} моделей",
    selectBrandTitle: "Марка не выбрана",
    selectBrand: "Выберите марку слева, чтобы просмотреть, изменить или добавить модели.",
    noModels: "В этой марке пока нет моделей",
    noModelsHint: "Добавьте первую модель ниже.",
    addModelPlaceholder: "Название модели — Enter для добавления",
    addBrandPlaceholder: "Название новой марки — Enter для добавления",
    colors: "Цвета",
    colorsCount: "{{count}} цветов",
    addColorPlaceholder: "Название нового цвета",
    addColorNameRuPlaceholder: "Название на русском (необязательно)",
    noColors: "Пока нет цветов",
    noColorsHint: "Добавьте новый цвет ниже",
    deleteColorTitle: "Удалить цвет",
    deleteColorHint: "Цвет будет удалён из списка. Существующие договоры не изменятся.",
  },
  overview: {
    title: "Общий обзор",
    subtitle: "Кокпит оператора — текущее состояние системы",
    customers: "Клиенты",
    activeAgreements: "Активные договоры",
    overdue: "Просроченные платежи",
    outstandingDebt: "Остаток долга",
    merchants: "Мерчанты",
    premium: "Премиум-клиенты",
    circulating: "Оборотные средства",
    profit: "Прибыль",
    newThisMonth: "в этом месяце",
    clientsSuffix: "клиентов",
    som: "сум",
    last6Months: "Последние 6 месяцев",
    recentActivity: "Последняя активность",
    recentNotifications: "Последние уведомления",
    recentCustomers: "Новые клиенты",
    quickActions: "Быстрые действия",
    qaImport: "Импорт",
    qaNotify: "Уведомление",
    qaCustomers: "Клиенты",
    empty: "Нет данных для отображения",
    loadError: "Не удалось загрузить данные",
    loadErrorHint: "Обновите страницу или попробуйте снова.",
  },
  metrics: {
    title: "Метрики",
    tabs: {
      growth: "Рост",
      agreements: "Договоры",
      premium: "Премиум",
      engagement: "Активность",
    },
    presets: {
      "7d": "7 дней",
      "30d": "30 дней",
      "90d": "90 дней",
      "12m": "12 мес.",
      custom: "Свой период",
    },
    filter: {
      from: "Дата начала",
      to: "Дата окончания",
      prevPeriod: "Предыдущий период: {{from}} – {{to}}",
    },
    unit: {
      som: "сум",
      min: "мин",
      hour: "ч",
      day: "дн.",
    },
    common: {
      retry: "Повторить",
      loadError: "Не удалось загрузить метрики",
      loadErrorHint: "Повторите попытку или обновите страницу.",
      empty: "Нет данных за этот период",
      snapshot: "Текущее состояние",
      dataSince: "Данные об активности с {{date}}",
      appUpdateHint: "Появится после обновления мобильного приложения",
      vsPrev: "к предыдущему периоду",
      count: "Кол-во",
      share: "Доля",
      total: "Всего",
    },
    sections: {
      trend: "Динамика",
      totals: "Итого",
      byStatus: "По статусу",
      byType: "По типу",
      source: "Источник",
      active: "Активный премиум",
      expiring: "Скоро истекает премиум (7 дней)",
      byApp: "По приложению",
      retention: "Удержание",
      cohorts: "Недельные когорты",
      funnel: "Воронка",
      adoption: "Использование функций",
      platforms: "Платформы",
      appVersions: "Версии приложения",
    },
    kpi: {
      newMerchants: "Новые мерчанты",
      newMerchantsHint: "Пользователи, впервые добавленные как мерчанты за период.",
      newClients: "Новые клиенты",
      newClientsHint: "Пользователи, впервые добавленные как клиенты за период.",
      activeMerchants: "Активные мерчанты",
      activeMerchantsHint: "Мерчанты, создавшие хотя бы один договор (не черновик) за период.",
      clientAppActivation: "Активация клиентского приложения",
      clientAppActivationHint: "Клиенты, входившие в приложение / все клиенты. Текущее состояние, без сравнения с прошлым периодом.",
      totalMerchants: "Всего мерчантов",
      totalClients: "Всего клиентов",
      newAgreements: "Новые договоры",
      newAgreementsHint: "Договоры, созданные за период и не являющиеся черновиками.",
      volume: "Объём",
      volumeHint: "Сумма продажных цен этих договоров (в сумах).",
      acceptanceRate: "Доля принятия",
      acceptanceRateHint: "Доля активированных среди договоров, по которым принято решение за период (активные / (активные + отклонённые)).",
      medianAcceptMinutes: "Время принятия (медиана)",
      medianAcceptMinutesHint: "Медиана времени от запроса подтверждения до активации. Чем меньше, тем лучше.",
      revenue: "Доход",
      revenueHint: "Сумма успешных оплат премиума за период.",
      topups: "Пополнения",
      topupsHint: "Сумма успешных пополнений баланса за период.",
      paidActivations: "Платные активации",
      paidActivationsHint: "Количество платных активаций премиума за период.",
      freeActivations: "Бесплатные активации",
      freeActivationsHint: "Количество бесплатных активаций премиума за период.",
      freeToPaid: "Бесплатный → платный",
      freeToPaidHint: "Доля пользователей с истёкшим за период бесплатным премиумом, позже сделавших платную покупку.",
      dauAvg: "Средний DAU",
      dauAvgHint: "Среднее число уникальных активных пользователей за день периода.",
      wau: "WAU",
      wauHint: "Уникальные активные пользователи за последние 7 дней периода.",
      mau: "MAU",
      mauHint: "Уникальные активные пользователи за последние 30 дней периода.",
      stickiness: "Stickiness",
      stickinessHint: "DAU / MAU — как часто пользователи возвращаются в приложение.",
      d1: "D1",
      d1Hint: "Доля вернувшихся на 1-й день после первого активного дня.",
      d7: "D7",
      d7Hint: "Доля вернувшихся на 7-й день после первого активного дня.",
      d30: "D30",
      d30Hint: "Доля вернувшихся на 30-й день после первого активного дня.",
      cohortSize: "Размер когорты",
    },
    series: {
      newMerchants: "Новые мерчанты",
      newClients: "Новые клиенты",
      count: "Кол-во",
      volume: "Объём",
      revenue: "Доход",
      topups: "Пополнения",
      merchant: "Мерчант",
      client: "Клиент",
      total: "Всего",
    },
    status: {
      active: "Активный",
      rejected: "Отклонён",
      paused: "Приостановлен",
      pending: "Ожидает",
      draft: "Черновик",
      finished: "Завершён",
      cancelled: "Отменён",
    },
    type: {
      car: "Автомобиль",
      building: "Недвижимость",
      technology: "Техника",
      loan: "Заём",
      other: "Другое",
      service: "Услуга",
    },
    sourceKind: {
      app: "Приложение",
      imported: "Импорт",
    },
    platform: {
      ios: "iOS",
      android: "Android",
      web: "Web",
      unknown: "Неизвестно",
    },
    app: {
      merchant: "Мерчант",
      client: "Клиент",
    },
    funnel: {
      signup: "Регистрация",
      profile: "Профиль заполнен",
      first_client: "Первый клиент",
      first_agreement: "Первый договор",
      paid_premium: "Платный премиум",
      ofPrev: "от предыдущего шага",
    },
    adoption: {
      activeMerchants: "Активные мерчанты",
      agreements: "Создавали договоры",
      payments: "Вносили платежи",
      debts: "Пользовались долгами",
      clients: "Добавляли клиентов",
      clientPaymentShare: "Доля платежей, внесённых клиентом",
    },
    premium: {
      total: "Всего активных",
      paid: "Платные",
      free: "Бесплатные",
      willRenew: "Продлится",
      wontRenew: "Не продлится",
      colName: "Имя",
      colPhone: "Телефон",
      colEnd: "Дата окончания",
      colType: "Тип",
      colRenew: "Автопродление",
      colBalance: "Баланс",
      viewAll: "Смотреть все →",
    },
    cohort: {
      week: "Неделя",
      size: "Размер",
      weekN: "Нед. {{n}}",
    },
  },
  renewals: {
    title: "Клиенты",
    subtitle:
      "Мерчанты, у которых подходит или прошёл срок премиума — посмотрите активность и позвоните, чтобы перевести на Pro или продлить",
    statusExpiring: "Истекает",
    statusExpired: "Истёк",
    daysLabel: "Период",
    daysOption: "{{n}} дн.",
    kindLabel: "Тип премиума",
    kind_all: "Все",
    kind_free: "Free",
    kind_paid: "Платный",
    searchPlaceholder: "Поиск по имени или телефону",
    total: "Всего: {{count}}",
    rangeShown: "Показано {{from}}–{{to}} из {{total}}",
    colMerchant: "Мерчант",
    colPremium: "Премиум",
    colTerm: "Срок",
    colAgreements: "Договоры",
    colClients: "Клиенты",
    colActivity: "Активность",
    agreementsHint: "Число активных договоров. Ниже — их ещё не оплаченный остаток (USD).",
    clientsHint: "Клиенты с полностью заполненными данными (имя, фамилия, ПИНФЛ, паспорт, адрес, дата рождения), принявшие хотя бы один договор. Ниже — всего клиентов.",
    activityHint: "Время последнего входа. Полоска — сколько дней из последних 30 был активен.",
    activeShort: "акт.",
    clientsTotal: "всего {{n}}",
    neverLoggedIn: "Не входил",
    free: "Free",
    paid: "Платный",
    endsToday: "Истекает сегодня",
    daysLeft: "Осталось {{n}} дн.",
    endedAgo: "Истёк {{n}} дн. назад",
    new30d: "+{{n}} за 30 дней",
    activeDays: "Активен {{n}} из последних 30 дней",
    copy: "Скопировать номер",
    copied: "Скопировано",
    openMerchant: "{{name}} — открыть карточку",
    empty: "Мерчанты не найдены",
    emptyHint: "Попробуйте изменить фильтры.",
    loadError: "Не удалось загрузить данные.",
    retry: "Повторить",
  },
};
